import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const Loader = () => (
  <div
    data-testid="auth-loading"
    className="min-h-screen flex items-center justify-center bg-slate-50"
  >
    <div className="h-8 w-8 border-2 border-slate-300 border-t-blue-700 rounded-full animate-spin" />
  </div>
);

export const isSuperAdmin = (role) => role === "super_admin" || role === "admin";
export const isFranchiseAdmin = (role) => role === "franchisee_admin" || isSuperAdmin(role);

export function homeRouteFor(user) {
  if (!user) return "/login";
  if (isSuperAdmin(user.role)) return "/admin";
  if (user.role === "franchisee_admin") return "/franchise";
  return "/dashboard";
}

export function ProtectedRoute({ children, adminOnly = false, franchiseOnly = false }) {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (user === false) return <Navigate to="/login" replace />;
  if (adminOnly && !isSuperAdmin(user.role)) return <Navigate to={homeRouteFor(user)} replace />;
  if (franchiseOnly && !isFranchiseAdmin(user.role)) return <Navigate to={homeRouteFor(user)} replace />;
  return children;
}

export function RootRedirect() {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  return <Navigate to={homeRouteFor(user)} replace />;
}
